<div class="dialog-container">
  <!-- Title -->
  <h2 mat-dialog-title>Delete User</h2>
  <mat-dialog-content>
    Are you sure you want to delete User: {{ data.FirstName }} {{ data.LastName }}?
    <br />

    @if (apiErrorMessage()) {
      <div style="margin-top: 24px" class="alert-danger">User Delete Error: {{ apiErrorMessage() }}</div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" mat-dialog-close>Cancel</button>
    <button (click)="deleteUser()" mat-button cdkFocusInitial class="btn-red">Delete</button>
  </mat-dialog-actions>
</div>
